import type CameraControls from 'camera-controls'

/**
 * Tune the existing camera-controls instance for BIM navigation.
 *
 * No fork of camera-controls or That Open is installed. The integration uses
 * public properties already present in the project's dependency, which keeps
 * it compatible with both perspective and orthographic cameras.
 */
export function installEnhancedCameraControls(
  controls: CameraControls,
): () => void {
  const previous = {
    dollyToCursor: controls.dollyToCursor,
    dollySpeed: controls.dollySpeed,
    smoothTime: controls.smoothTime,
    draggingSmoothTime: controls.draggingSmoothTime,
    infinityDolly: controls.infinityDolly,
    restThreshold: controls.restThreshold,
  }

  // Zoom follows the element under the pointer instead of the screen centre.
  controls.dollyToCursor = true
  // SmoothDamp provides wheel momentum without maintaining a second RAF loop.
  controls.smoothTime = 0.18
  controls.draggingSmoothTime = 0.075
  controls.dollySpeed = 0.85
  controls.infinityDolly = true
  controls.restThreshold = 0.004

  return () => {
    controls.dollyToCursor = previous.dollyToCursor
    controls.dollySpeed = previous.dollySpeed
    controls.smoothTime = previous.smoothTime
    controls.draggingSmoothTime = previous.draggingSmoothTime
    controls.infinityDolly = previous.infinityDolly
    controls.restThreshold = previous.restThreshold
  }
}

